import { Alert, AlertTitle, List, ListItem } from '@mui/material';

interface FormErrorSummaryProps {
  errors: Record<string, any>;
  title?: string;
}

const FormErrorSummary: React.FC<FormErrorSummaryProps> = ({
  errors,
  title = 'Errori di validazione'
}) => {
  const errorMessages = Object.entries(errors).map(([field, error]) => ({
    field,
    message: error?.message as string
  })).filter(e => e.message);

  if (errorMessages.length === 0) return null;

  return (
    <Alert
      severity="error"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      sx={{ mb: 3 }}
    >
      <AlertTitle>{title}</AlertTitle>
      <List dense sx={{ mt: 1 }}>
        {errorMessages.map(({ field, message }) => (
          <ListItem key={field} sx={{ py: 0.5, px: 0 }}>
            • {message}
          </ListItem>
        ))}
      </List>
    </Alert>
  );
};

export default FormErrorSummary;
